import { render, staticRenderFns } from "./searchByname.vue?vue&type=template&id=6a80e394&scoped=true&"
import script from "./searchByname.ts?vue&type=script&lang=js&"
export * from "./searchByname.ts?vue&type=script&lang=js&"
import style0 from "./searchByname.less?vue&type=style&index=0&id=6a80e394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80e394",
  null
  
)

export default component.exports